<template>
  <main>
      <headerElem></headerElem>
    <div class="mentions" v-html="mentions" />
  </main>
</template>
<script>
import HeaderElem from "@/components/Header";
export default {
  name: "mentions",
      components: {
    HeaderElem,
  },
  data() {
    return {
      mentions: window.mentions,
    };
  },
};
</script>
